<template>
  <v-chart class="chart" :option="option" />
</template>

<script>
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { PieChart } from "echarts/charts";
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
} from "echarts/components";
import VChart, { THEME_KEY } from "vue-echarts";

use([
  CanvasRenderer,
  PieChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
]);

export default {
  name: "gauge",
  components: {
    VChart,
  },
  //背景颜色
  provide: {
    [THEME_KEY]: "",
  },
  props: {
    value: {
      type: Array,
    },
    axis: {
      type: Array,
    },
  },
  data() {
    return {
      option: {
        title: {
          text: "原料使用量",
          top: 20,
          left: "35%",
          textStyle: {
            fontSize: 15,
            color: "#fff",
          },
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          top: 25,
          right: 15,
          data: [
            { name: "长石粉", icon: "circle" },
            { name: "方解石", icon: "circle" },
          ],
          textStyle: {
            fontSize: 10,
            color: "#fff",
          },
          itemWidth: 10,
          itemHight: 10,
        },
        grid: {
          // left: "1%",
          // right: "1%",
          // bottom: "1%",
          // containLabel: true,
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "category",
          // boundaryGap: false,
          data: this.axis,
          axisTick: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: "#fff",
            },
          },
        },
        yAxis: {
          type: "value",
          show: true,
          offset: 0,
          axisLine: {
            show: true,
            onZero: true,
          },
          minorTick: {
            show: false,
          },
          //y轴的次刻度线（类目轴不显示，其余都显示,即y轴横线）
          splitLine: {
            show: false,
          },
          //轴刻度相关
          axisLabel: {
            color: "#fff",
          },
        },
        series: this.value,
      },
    };
  },
  watch: {
        value(newVal) {
          this.option.series = newVal
        },
        axis(newVal) {
          this.option.xAxis.data = newVal
        }
      },
};
</script>

<style scoped>
.chart {
  width: 400px;
  height: 320px;
}
</style>


// WEBPACK FOOTER //
// src/components/test10Children/production.vue